/* VALKA · encabezado: menú lateral accesible, resaltado de la sección visible y contador del carrito en vivo. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setOffset(header) {
    var h = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--vxl-header-offset', Math.round(h + 12) + 'px');
  }

  function setCount(count) {
    document.querySelectorAll('[data-vxl-count]').forEach(function (el) {
      var prev = el.textContent.trim();
      var next = count > 99 ? '99+' : String(count);
      el.textContent = next;
      el.hidden = !count;
      if (prev !== next && count) {
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
    document.querySelectorAll('[data-vxl-cart-link]').forEach(function (a) {
      var tpl = count === 1 ? a.getAttribute('data-label-one') : a.getAttribute('data-label-other');
      if (tpl) a.setAttribute('aria-label', tpl.replace('[n]', count));
    });
  }

  function fetchCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        setCount(c.item_count);
      })
      .catch(function () {});
  }

  function initDrawer(header) {
    var opener = header.querySelector('[data-vxl-open]');
    if (!opener) return;
    var id = opener.getAttribute('aria-controls');
    var drawer = header.parentNode.querySelector('#' + id) || document.getElementById(id);
    if (!drawer) return;
    // Sacar el menú del contenedor fijo para que quede por encima de todo.
    document.querySelectorAll('body > #' + id).forEach(function (old) {
      if (old !== drawer) old.remove();
    });
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

    var panel = drawer.querySelector('.vxl-drawer__panel');
    var lastFocus = null;
    var closeTimer;

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) {
          return el.offsetParent !== null;
        }
      );
    }

    function open() {
      clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('vxl-lock');
      var f = focusables();
      (f[1] || f[0] || panel).focus();
    }

    function close(restore) {
      if (drawer.hidden) return;
      drawer.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('vxl-lock');
      closeTimer = setTimeout(function () {
        drawer.hidden = true;
      }, reduce ? 0 : 350);
      if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus();
    }

    opener.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-vxl-close]')) {
        close();
        return;
      }
      var link = e.target.closest('a[href]');
      if (link) close(false);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990 && !opener.offsetParent) close(false);
    });
  }

  function hashOf(a) {
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i < 0) return null;
    var path = href.slice(0, i) || location.pathname;
    try {
      var url = new URL(path, location.origin);
      if (url.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return null;
    } catch (err) {
      return null;
    }
    return href.slice(i + 1) || null;
  }

  function initSpy(header) {
    var links = Array.prototype.slice.call(document.querySelectorAll('.vxl-h__link, .vxl-drawer__item'));
    var map = [];
    links.forEach(function (a) {
      var h = hashOf(a);
      var target = h && document.getElementById(decodeURIComponent(h));
      if (target) map.push({ a: a, id: h, el: target });
    });

    // Desplazamiento suave a las anclas de la misma página.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var h = hashOf(a);
      var target = h && document.getElementById(decodeURIComponent(h));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + h);
      setActive(h);
    });

    if (!header.hasAttribute('data-vxl-spy') || !map.length) return;
    var ids = [];
    map.forEach(function (m) {
      if (ids.indexOf(m.id) === -1) ids.push(m.id);
    });
    var current = null;
    var lock = 0;

    function setActive(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (a) {
        var on = hashOf(a) === id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    function update() {
      lock = 0;
      var offset = header.getBoundingClientRect().bottom + 24;
      var active = ids[0];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el && el.getBoundingClientRect().top - offset <= 0) active = ids[i];
      }
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        var lastEl = document.getElementById(ids[ids.length - 1]);
        if (lastEl && lastEl.getBoundingClientRect().top < window.innerHeight) active = ids[ids.length - 1];
      }
      setActive(active);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!lock) lock = requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var header = document.querySelector('[data-vxl-header]');
    if (!header) return;
    setOffset(header);
    window.addEventListener('resize', function () {
      setOffset(header);
    });
    initDrawer(header);
    initSpy(header);
  }

  document.addEventListener('vxl:cart', function (e) {
    if (e.detail && typeof e.detail.count === 'number') setCount(e.detail.count);
  });

  function subscribeDawn() {
    // PUB_SUB_EVENTS es una constante global de Dawn (no es propiedad de window).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.cartData && typeof ev.cartData.item_count === 'number') setCount(ev.cartData.item_count);
        else fetchCount();
      });
    }
  }

  // Al volver con el botón "atrás" el contador puede estar desactualizado.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) fetchCount();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      subscribeDawn();
    });
  } else {
    init();
    subscribeDawn();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-vxl-header]')) init();
  });
})();
